import * as React from "react";
import Svg from "./StyledSvg";
type Props = {
  size?: number | string;
  color?: string;
  style?: object;
};
function GiftMedium({
  size = 16,
  color = "currentColor",
  style
}: Props): React.JSX.Element {
  return <Svg width={size} height={size} viewBox="0 0 24 24" fill={color} style={style}><path fillRule="evenodd" clipRule="evenodd" d="M8.837 2.165a3.4 3.4 0 013.49 1.446l.01.014A2.9 2.9 0 0116.682 7.1H19a2.9 2.9 0 01.9 5.657V19a2.9 2.9 0 01-2.9 2.9H7A2.9 2.9 0 014.1 19v-6.243A2.899 2.899 0 015 7.1h1.5a3.4 3.4 0 012.337-4.935zM9.5 7.1h1.6V5.5a1.6 1.6 0 10-1.6 1.6zm3.4 0V6A1.1 1.1 0 1114 7.1h-1.1zm-7 5.8V19A1.1 1.1 0 007 20.1h4.1v-7.2H5.9zm7 0v7.2H17a1.1 1.1 0 001.1-1.1v-6.1h-5.2zm0-1.8V8.9H19a1.1 1.1 0 010 2.2h-6.1zm-1.8-2.2v2.2H5a1.1 1.1 0 010-2.2h6.1z"  /></Svg>;
}
export default GiftMedium;